import { render } from "./SessionUpdateComponent.vue?vue&type=template&id=5f97dca2&scoped=true"
import script from "./SessionUpdateComponent.vue?vue&type=script&lang=js"
export * from "./SessionUpdateComponent.vue?vue&type=script&lang=js"

import "./SessionUpdateComponent.vue?vue&type=style&index=0&id=5f97dca2&lang=scss&scoped=true"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f97dca2"]])

export default __exports__